import { render, staticRenderFns } from "./AgentMgVanCollapseContenty.vue?vue&type=template&id=7e96a638&scoped=true"
import script from "./AgentMgVanCollapseContenty.vue?vue&type=script&lang=js"
export * from "./AgentMgVanCollapseContenty.vue?vue&type=script&lang=js"
import style0 from "./AgentMgVanCollapseContenty.vue?vue&type=style&index=0&id=7e96a638&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e96a638",
  null
  
)

export default component.exports